"use client";

import FieldsFormatter from "@/components/organisms/admin/FieldsFormatter";
import { Button } from "@/components/atoms/Button";
import { TreeConfig, FormState, Section } from "../types";

interface FormSectionProps {
  formState: FormState;
  treeConfig: TreeConfig;
  fieldsConfig: any[];
  onFieldsUpdate: (data: any) => void;
  onSave: (callback: (updatedSection: Section) => void) => void;
  onNewItem: () => void;
  onSaveCallback: (updatedSection: Section) => void;
}

export const FormSection = ({
  formState,
  treeConfig,
  fieldsConfig,
  onFieldsUpdate,
  onSave,
  onNewItem,
  onSaveCallback,
}: FormSectionProps) => {
  return (
    <div className="border-t pt-6 relative">
      <h4 className="font-semibold mb-4">
        {formState.editingItemId ? treeConfig.formLabels.edit : treeConfig.formLabels.addNew}
      </h4>

      <FieldsFormatter
        data={formState.componentFields}
        fields={fieldsConfig}
        updateParent={true}
        onChange={onFieldsUpdate}
        validationErrors={formState.componentFieldErrors}
        validationMessages={formState.componentFieldMessages}
        className="p-0 bg-transparent"
      />

      <div className="mt-6 flex gap-2">
        <Button onClick={() => onSave(onSaveCallback)} classType="admin" className="flex-1">
          {formState.editingItemId
            ? treeConfig.formLabels.updateButton
            : treeConfig.formLabels.saveButton}
        </Button>
        {formState.editingItemId && (
          <Button
            onClick={onNewItem}
            classType="admin"
            className="px-4 bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            {treeConfig.formLabels.cancelButton}
          </Button>
        )}
      </div>
    </div>
  );
};

